<div class="wrapper">
     @if(wheelHeader()){
        <app-wheel-dynamic-text [data]="wheelHeader()!" class="wheel-header"></app-wheel-dynamic-text>
     }

     @if(wheelDescription()){
        <app-wheel-dynamic-text [data]="wheelDescription()!" class="wheel-description"></app-wheel-dynamic-text>
     }


    @if(showSpinMarket()){
        <div class="spin-market">
            @for (item of bonusMarketOptions(); track $index) {
                <app-wheel-bonus-card [balance]="bonusBalance()" [data]="item" (buySpins)="handleBuySpins($event)"></app-wheel-bonus-card>
            }
        </div>
    }
    @else {
        @if(showTrophy()){
            <div class="wheel-result">
                <app-wheel-trophy [data]="wheelTrophy()"></app-wheel-trophy>
            </div>
            }
            @else {
                <div class="wheel-container">
                    <div class="static-screen">
                        <img src="assets/icons/wheel-arrow.svg" alt="" [ngClass]="{'grayscale-filter':!canSpin(), 'wheel-arrow': true}">
                    </div>
                <canvas #wheelCanvas class="wheel__canvas"></canvas>
                
            </div>    
            }
    }

   
    @if(wheelSubtitle()){
        <app-wheel-dynamic-text [data]="wheelSubtitle()!" class="wheel-subtitle"></app-wheel-dynamic-text>
    }

    <div class="wheel-buttons" [ngClass]="[showSpinMarket()?'mt-auto pb-40':'']">
        @for (button of wheelButtons(); track button.action) {
    
        @if(button.action === WHEEL_BUTTON_ACTION.AUTHORIZE){
            <ng-content select=".wheel-login"></ng-content>
        }
        @else {
            <app-wheel-button [data]="button" (click)="wheelClickHandler(button.action)" [disabled]="isLoading()"></app-wheel-button>
        }
        }
        @if(showWheelGuy()){
            <img src="assets/bonus-guy.png" width="120px" class="wheel-guy"/>
        }
        
    </div>
</div>
<ng-template #errorRef>{{errorMessage()}}</ng-template>